export default "__VITE_ASSET__Bl_dG3oL__"